const artists = [
    "Henri Ardui",
    "Jolijn Baeckelandt",
    "Jelle Crama",
    "Catharina Dhaen",
    "Gilles Dedecker",
    "Tom Dries",
    "Charlotte Dumortier",
    "Roel Goessey",
    "Yuriko Myochi",
    "An Onghena",
    "Juan Pablo Plazas",
    "Serge Proth",
    "Emmanuelle Quertain",
    "Mieke Robroeks",
    "Veerle Rooms",
    "Juliane Schreiber",
    "Zoé Schreiber",
    "Karen Spiessens",
    "Xox is not alone",
    "Zena Van den Block",
    "Benny Van den Meulengracht-Vranckx",
    "Tijs Van Nieuwenhuysen",
    "Lore Van Roelen & Robert Soroko",
    "Emma Verhulst"
];

export default artists;